import styles from "./fifty-thirty-twenty.module.css"

import React from "react"
import * as util from "activities/util"
import * as shared from "activities/components/shared"
import * as inputs from "activities/components/inputs"
import * as callouts from "activities/components/callouts"
import assign from "object-assign"

const fiftyThirtyTwenty = (income) => ({
  needs: income * 0.5,
  wants: income * 0.3,
  savings: income * 0.2
})

export default shared.ActivityFactory(
  ({getState, getProps, updateState}) => {
    const {income, resetKey} = getState()
    const {id} = getProps()
    const {needs, wants, savings} = fiftyThirtyTwenty(income)
    return (
      <div>
        <shared.Content className={styles["content"]}>
          <shared.Calculator className={styles["calculator"]}>
            <inputs.CalcInput
              id={id}
              title="Monthly After-Tax Income"
              onChange={updateState("income", util.fromString)}
              placeholder="$3,400"
              resetKey={resetKey}
              initialValue={income}
            />
          </shared.Calculator>
        </shared.Content>
        <callouts.Callout>
          <callouts.Detail label="Needs (50%)" result={util.formatDollarsNoCents(needs)} dataTestId={"fifty"} />
          <callouts.Detail label="Wants (30%)" result={util.formatDollarsNoCents(wants)} dataTestId={"thirty"} />
          <callouts.Detail label="Savings (20%)" result={util.formatDollarsNoCents(savings)} dataTestId={"twenty"} />
        </callouts.Callout>
      </div>
    )
  },
  {
    stateFilter: (state) => {
      const {income} = state
      return assign(state, fiftyThirtyTwenty(income))
    },
    defaultProps: {
      id: "fifty-thirty-twenty",
      className: "fifty-thirty-twenty",
      title: "50/30/20 Calculator",
      subtitle: "Enter your monthly after-tax income below to see how the rule applies to you."
    },
    defaultState: {
      income: 0 // Monthly
    }
  }
)
